import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M1 7.9875L1.8875 8.875L6 4.7625L10.1125 8.875L11 7.9875L6 2.9875L1 7.9875Z"
	})
});
export default SvgChevronUp;
